import axios, { AxiosPromise } from 'axios'

export class AtencaoDomiciliar {
  gerarRelatorioAd(formData: FormData): AxiosPromise<Blob> {
    return axios.post('/api/atencaodomiciliar/gerarRelatorio', formData, { responseType: 'blob' })
  }
}
